import { Pagination } from "@mui/material";
import { MoreHorizontal } from "lucide-react";
import { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import toast from "react-hot-toast";
import { checkTagValidity } from "../../Utils/Utils";
import { ADD_FORFAIT, DELETE_FORFAIT } from "../../Utils/constant";
import { ForfaitForm } from "../../components/Forfait/ForfaitForm";
import { Home } from "../../components/Icons/Home";
import { Loader } from "../../components/Widget/Loader";
import { deleteOne, store } from "../../services/service";
import { useStoreEquipement } from "../../store/Paramettre/equipementStore";
import { useStoreForfait } from "../../store/Paramettre/forfaitStore";

export const Forfait = () => {
  const forfait = useStoreForfait();
  const typeEquipements = useStoreEquipement();
  const [selectItem, setSelectItem] = useState(null);
  const {
    register,
    handleSubmit,
    reset,
    formState: { errors },
  } = useForm();
  const [isSubmit, setIsSubmit] = useState(false);
  const [selectType, setSelectType] = useState("");

  const submit = (data) => {
    setIsSubmit(true);
    store(ADD_FORFAIT, "application/json", data)
      .then((res) => {
        setIsSubmit(false);
        if (res.status === 200) {
          reset();
          document.getElementById("fermer_create").click();
          toast.success("Forfait ajouté");
          forfait.forfait({ page: 0, param: "", size: 10 });
        }
      })
      .catch((err) => {
        setIsSubmit(false);
        toast.error(err.response.data.donnee);
      });
  };

  useEffect(() => {
    reset();
    forfait.forfait({ page: 0, param: "", size: 10 });
    typeEquipements.equipement({ page: 0, param: "", size: 10 });
  }, []);

  const more = (page) =>
    forfait.forfait({ page: page - 1, param: "", size: 10 });

  const inputCls =
    "w-full h-10 px-3 border border-gray-200 rounded-lg text-sm text-gray-900 bg-gray-50 outline-none focus:border-yellow-400 focus:ring-2 focus:ring-yellow-100 transition";
  const selectCls =
    "w-full h-10 px-3 border border-gray-200 rounded-lg text-sm text-gray-900 bg-gray-50 outline-none focus:border-yellow-400 focus:ring-2 focus:ring-yellow-100 transition";

  return (
    <>
      {/* Header */}
      <div className="mt-4 mb-1">
        <p className="text-2xl font-bold text-gray-900 tracking-tight">
          Forfaits
        </p>
        <p className="text-sm text-gray-400 mt-1">
          Gestion des forfaits et leurs configurations
        </p>
      </div>

      {/* Toolbar */}
      <div className="flex flex-wrap items-center gap-3 py-4 border-b border-gray-100 mb-6">
        <div className="flex items-center gap-2 bg-gray-50 border border-gray-200 rounded-xl px-3 h-10">
          <svg
            width="15"
            height="15"
            viewBox="0 0 24 24"
            fill="none"
            stroke="#9ca3af"
            strokeWidth="2"
          >
            <circle cx="11" cy="11" r="8" />
            <path d="m21 21-4.35-4.35" />
          </svg>
          <input
            type="text"
            placeholder="Rechercher un forfait…"
            onChange={(e) =>
              forfait.forfait({ page: 0, param: e.target.value, size: 10 })
            }
            className="bg-transparent border-none outline-none text-sm text-gray-900 placeholder-gray-400 w-full lg:w-64"
          />
        </div>

        {checkTagValidity("AJOUTER_FORFAIT") && (
          <button
            onClick={() => document.getElementById("modal_create").showModal()}
            className="ml-auto h-10 px-4 bg-yellow-400 hover:bg-yellow-300 text-gray-900 text-sm font-semibold rounded-lg transition"
          >
            Ajouter un forfait
          </button>
        )}
      </div>

      {/* Create Modal */}
      <dialog id="modal_create" className="modal">
        <div className="modal-box rounded-2xl p-6 max-w-lg">
          <div className="flex items-center justify-between mb-5">
            <h2 className="text-lg font-bold text-gray-900">Nouveau forfait</h2>
            <form method="dialog">
              <button
                id="fermer_create"
                className="w-8 h-8 flex items-center justify-center rounded-lg bg-gray-100 hover:bg-gray-200 text-gray-500 text-sm font-semibold transition"
              >
                ✕
              </button>
            </form>
          </div>

          <form onSubmit={handleSubmit(submit)} className="space-y-4">
            {/* Designation */}
            <div>
              <label className="block text-xs font-medium text-gray-700 mb-1.5">
                Désignation <span className="text-red-500">*</span>
              </label>
              <input
                type="text"
                className={inputCls}
                {...register("designation", { required: true })}
              />
              {errors.designation && (
                <p className="text-xs text-red-500 mt-1">
                  Ce champ est obligatoire
                </p>
              )}
            </div>

            {/* Cout */}
            <div>
              <label className="block text-xs font-medium text-gray-700 mb-1.5">
                Coût du forfait <span className="text-red-500">*</span>
              </label>
              <input
                type="text"
                className={inputCls}
                {...register("cout", { required: true })}
              />
              {errors.cout && (
                <p className="text-xs text-red-500 mt-1">
                  Ce champ est obligatoire
                </p>
              )}
            </div>

            {/* Code souscription */}
            <div>
              <label className="block text-xs font-medium text-gray-700 mb-1.5">
                Code de souscription <span className="text-red-500">*</span>
              </label>
              <input
                type="text"
                className={inputCls}
                {...register("codeSouscription", { required: true })}
              />
              {errors.codeSouscription && (
                <p className="text-xs text-red-500 mt-1">
                  Ce champ est obligatoire
                </p>
              )}
            </div>

            <div className="my-2">
              <label htmlFor="" className="text-sm font-medium">
                Code de souscription air <span className="text-red-500">*</span>
              </label>
              <input
                type="text"
                placeholder=""
                className={inputCls}
                {...register("codeSouscriptionAir", { required: true })}
              />
              {errors.codeSouscriptionAir && (
                <span className="text-sm text-rose-600">
                  Ce champs est obligatoire
                </span>
              )}
            </div>

            {/* OfferId */}
            <div>
              <label className="block text-xs font-medium text-gray-700 mb-1.5">
                OfferId <span className="text-red-500">*</span>
              </label>
              <input
                type="text"
                className={inputCls}
                {...register("offerId", { required: true })}
              />
              {errors.offerId && (
                <p className="text-xs text-red-500 mt-1">
                  Ce champ est obligatoire
                </p>
              )}
            </div>

            {/* Type équipement */}
            <div>
              <label className="block text-xs font-medium text-gray-700 mb-1.5">
                Type d'équipement <span className="text-red-500">*</span>
              </label>
              <select
                {...register("typeEquipementId", { required: true })}
                onChange={(e) => setSelectType(e.target.value)}
                className={selectCls}
              >
                <option value="">Sélectionner un type</option>
                {typeEquipements?.data?.equipements?.map((item) => (
                  <option key={item.id} value={item.id}>
                    {item.designation}
                  </option>
                ))}
              </select>
            </div>

            {/* Catégorie */}
            <div>
              <label className="block text-xs font-medium text-gray-700 mb-1.5">
                Catégorie <span className="text-red-500">*</span>
              </label>
              <select
                {...register("categorie", { required: true })}
                className={selectCls}
              >
                <option value="">Sélectionner une catégorie</option>
                <option value="PRE_PAID">Forfait prépayé</option>
                <option value="POST_PAID">Forfait postpayé</option>
              </select>
            </div>

            {/* Description */}
            <div>
              <label className="block text-xs font-medium text-gray-700 mb-1.5">
                Avantages du forfait
              </label>
              <textarea
                {...register("description")}
                rows={3}
                placeholder="Décrivez les avantages…"
                className="w-full px-3 py-2 border border-gray-200 rounded-lg text-sm text-gray-900 bg-gray-50 outline-none focus:border-yellow-400 focus:ring-2 focus:ring-yellow-100 transition resize-none"
              />
            </div>

            {/* Submit */}
            <button
              type="submit"
              disabled={isSubmit}
              className={`w-full h-10 rounded-xl text-sm font-semibold flex items-center justify-center gap-2 transition ${
                isSubmit
                  ? "bg-gray-100 text-gray-400 cursor-not-allowed"
                  : "bg-yellow-400 hover:bg-yellow-300 text-gray-900"
              }`}
            >
              {isSubmit ? (
                <>
                  <span className="loading loading-spinner loading-xs" />{" "}
                  Enregistrement…
                </>
              ) : (
                "Enregistrer"
              )}
            </button>
          </form>
        </div>
      </dialog>

      {/* Update Modal */}
      <dialog id="forfait_upadate" className="modal">
        <div className="modal-box rounded-2xl p-6 max-w-lg">
          <div className="flex items-center justify-between mb-5">
            <h2 className="text-lg font-bold text-gray-900">
              Modifier le forfait
            </h2>
            <form method="dialog">
              <button
                id="fermer"
                className="w-8 h-8 flex items-center justify-center rounded-lg bg-gray-100 hover:bg-gray-200 text-gray-500 text-sm font-semibold transition"
              >
                ✕
              </button>
            </form>
          </div>
          <ForfaitForm item={selectItem} />
        </div>
      </dialog>

      {/* Delete Modal */}
      <dialog id="delete" className="modal">
        <div className="modal-box rounded-2xl p-6 max-w-md">
          <p className="text-base font-bold text-gray-900 mb-1">
            Confirmer la suppression
          </p>
          <p className="text-sm text-gray-500 mb-6">
            Le forfait{" "}
            <span className="font-semibold text-gray-800">
              {selectItem?.designation}
            </span>{" "}
            sera définitivement supprimé.
          </p>
          <div className="flex justify-end gap-2">
            <form method="dialog">
              <button className="h-9 px-4 rounded-lg text-sm font-medium bg-gray-100 hover:bg-gray-200 text-gray-700 transition">
                Annuler
              </button>
            </form>
            <form method="dialog">
              <button
                onClick={() => {
                  deleteOne(DELETE_FORFAIT, selectItem.id)
                    .then(() => {
                      forfait.forfait({ page: 0, param: "", size: 10 });
                      toast.success(`${selectItem.designation} supprimé`);
                    })
                    .catch(() => {});
                }}
                className="h-9 px-4 rounded-lg text-sm font-medium bg-red-500 hover:bg-red-600 text-white transition"
              >
                Supprimer
              </button>
            </form>
          </div>
        </div>
      </dialog>

      {/* Grid */}
      {forfait?.loading ? (
        <Loader />
      ) : forfait?.data?.data?.length === 0 ? (
        <div className="flex items-center justify-center h-48">
          <p className="text-sm text-gray-400">Aucun forfait trouvé</p>
        </div>
      ) : (
        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 xl:grid-cols-4 gap-3">
          {forfait?.data?.data?.map((item) => (
            <div
              key={item.id}
              className="relative bg-white border border-gray-200 rounded-xl p-3 flex items-start gap-3 hover:shadow-md hover:border-yellow-300 transition-all duration-200"
            >
              {/* Menu */}
              <div className="dropdown dropdown-end absolute top-2 right-2">
                <div
                  tabIndex={0}
                  role="button"
                  className="w-7 h-7 flex items-center justify-center rounded-lg border border-gray-200 bg-white hover:bg-gray-50 text-gray-500 transition cursor-pointer"
                >
                  <MoreHorizontal size={15} />
                </div>
                <ul
                  tabIndex={0}
                  className="dropdown-content z-10 mt-1 bg-white border border-gray-200 rounded-xl shadow-lg w-40 p-1.5"
                >
                  <li>
                    <button
                      className="w-full h-8 px-3 text-left text-xs font-medium text-gray-700 rounded-lg hover:bg-gray-50 transition"
                      onClick={() => {
                        setSelectItem(item);
                        document.getElementById("forfait_upadate").showModal();
                      }}
                    >
                      Modifier
                    </button>
                  </li>
                  <li>
                    <button
                      className="w-full h-8 px-3 text-left text-xs font-medium text-red-600 rounded-lg hover:bg-red-50 transition"
                      onClick={() => {
                        setSelectItem(item);
                        document.getElementById("delete").showModal();
                      }}
                    >
                      Supprimer
                    </button>
                  </li>
                </ul>
              </div>

              {/* Icon */}
              <div className="w-10 h-10 rounded-xl bg-gray-100 flex items-center justify-center shrink-0">
                <Home />
              </div>

              {/* Info */}
              <div className="flex-1 min-w-0 pt-0.5">
                <p className="text-xs font-semibold text-gray-900 truncate">
                  {item?.designation}
                </p>
                <span className="inline-block mt-1.5 text-xs font-medium text-gray-600 bg-gray-100 rounded-full px-2 py-0.5">
                  {item?.categorie?.replace("_", " ").toLowerCase()}
                </span>
              </div>
            </div>
          ))}
        </div>
      )}

      {/* Pagination */}
      <div className="flex justify-end mt-6">
        <Pagination
          onChange={(_, v) => more(v)}
          count={forfait.count}
          variant="outlined"
          color="primary"
          shape="rounded"
          size="small"
        />
      </div>
    </>
  );
};
